import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";
import { type ComponentProps } from "react";

import { cn } from "../../utils/cn.util";

export type DropdownMenuRadioGroupProps = ComponentProps<typeof DropdownMenuPrimitive.RadioGroup>;

export const RadioGroup = ({ ref, className, ...props }: DropdownMenuRadioGroupProps) => (
  <DropdownMenuPrimitive.RadioGroup ref={ref} className={cn("flex flex-col gap-1", className)} {...props} />
);

RadioGroup.displayName = DropdownMenuPrimitive.RadioGroup.displayName;
